import * as React from 'react';
import { createContextValueGetter } from '../../utils/helper';
export var DropdownContext = React.createContext({ visible: true, zIndex: 9999 });
export var getDropdownContext = createContextValueGetter();
